import { GTM } from '@gamiphy/bl/integrations/gtm';
import { Http } from '@gamiphy/http';

export type GTMResponse = {
  gtm: GTM
}

export class GTMApi {
  public static async getGTM(): Promise<GTM | null> {
    const response = await Http.get<GTMResponse>({
      url: '/v2/apps/integrations/gtm',
    });
    return response.data.gtm;
  }
}
